import type { SortOrder } from './types';

export const isSortOrder = (value: unknown): value is SortOrder => (
  (typeof value === 'string' && [
    'price', 'name', 'rating', 'release_date',
  ].includes(value.split(',')[0]) && [
    'asc', 'desc',
  ].includes(value.split(',')[1])) || value === ''
);
